
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: 'editable-package-field',
    props: {
        packages: {
            type: Array as PropType<string[]>,
            required: true
        },
        onChangePackages: {
            type: Function as PropType<() => void>,
            required: true
        }
    }
})
